module.exports = __webpack_public_path__ + "img/cotizacion_agente.ca1118f3.svg";